var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"消息管理","fullscreen":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('MessageM',{attrs:{"doctorId":_vm.doctorId,"hideTitle":true,"readOnly":_vm.readOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }